import { apiRequest } from '../Api/ApiRequest';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function api_getSignature(signatureId) {

  return apiRequest({
    url: `/signatures/${signatureId}`,
    method: 'get',
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function api_getSignatures() {

  return apiRequest({
    url: '/signatures?include=hellosign,signatories,relatedTo',
    method: 'get',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function api_downloadSignature(id) {

  return apiRequest({
    url: `/signatures/${id}/download`,
    method: 'get',
    responseType: 'blob',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );

}
